import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/futbol': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M483.8 179.4c42.3 130.2-29 270.1-159.2 312.4-25.5 8.3-51.3 12.2-76.7 12.2-104.5 0-201.7-66.6-235.7-171.4-42.3-130.2 29-270.1 159.2-312.4 25.5-8.3 51.3-12.2 76.7-12.2 104.5 0 201.7 66.6 235.7 171.4zM409.3 373.1c6.1-8.4 12.1-16.9 16.8-26.2 14.3-28.1 21.5-58.5 21.7-89.2l-38.9-36.4-71.1 22.1-24.4 75.2 43.7 60.9zM409.3 137.7c-24.5-33.4-58.7-58.4-97.9-71.4l-47.4 26.2v73.8l64.2 46.5 70.7-22zM184.9 66.4c-39.9 13.3-73.5 38.5-97.8 71.9l10.1 52.5 70.6 22 64.2-46.5v-73.8zM139 379.5l43.5-61.7-24.3-74.3-71.1-22.2-39 36.4c0.5 55.7 23.4 95.2 37.8 115.3zM187.2 446.5c64.1 20.4 115.5 1.8 121.7 0l22.4-48.1-44.3-61.7h-78.6l-43.6 61.7z'
      }
    ]
  }
})
